import { Getter } from 'vuex'
import { MedicalDocumentState } from './state'

export default {
  /** @type {Getter<MedicalDocumentState, any>} */
  data: (state) => state.data,

  /** @type {Getter<MedicalDocumentState, any>} */
  currentStep: (state) => state.currentStep,
}
